import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AppLoader from "./components/common/AppLoader.vue";

import "./assets/tailwind.css";

import "./registerServiceWorker";
import { useTheme } from "./composables/useTheme";

// Initialize theme immediately
useTheme();

const app = createApp(App);

app.component("AppLoader", AppLoader);

store.dispatch("initializeUserRole"); // 👈 initialize user info from token

app.use(store).use(router).mount("#app");
